import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnonymousGuard } from '@services/anonymous-guard.service';
import { AuthGuard } from '@services/auth.guard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('@features/homepage/homepage.module').then(m => m.HomepageModule),
    canActivate: [AuthGuard],
    data: { title: 'pageTitles.home' }
  },
  {
    path: 'signup',
    loadChildren: () => import('@features/auth/signup/signup.module').then(m => m.SignupModule),
    canActivate: [AnonymousGuard],
    data: { title: 'pageTitles.signup' }
  },
  {
    path: 'login',
    loadChildren: () => import('@features/auth/login/login.module').then(m => m.LoginModule),
    canActivate: [AnonymousGuard],
    data: { title: 'pageTitles.login' }
  },
  {
    path: 'products',
    loadChildren: () => import('@features/products/products.module').then(m => m.ProductsModule),
    canActivate: [AuthGuard],
    data: { title: 'pageTitles.products' }
  },
  {
    path: 'orders',
    loadChildren: () => import('@features/orders/orders.module').then(m => m.OrdersModule),
    canActivate: [AuthGuard],
    data: { title: 'pageTitles.orders' }
  },
  {
    path: 'payouts',
    loadChildren: () => import('@features/payouts/payouts.module').then(m => m.PayoutsModule),
    canActivate: [AuthGuard],
    data: { title: 'pageTitles.payouts' }
  },
  {
    path: 'invoices',
    loadChildren: () => import('@features/invoices/invoices.module').then(m => m.InvoicesModule),
    canActivate: [AuthGuard],
    data: { title: 'pageTitles.invoices' }
  },
  {
    path: 'settings',
    loadChildren: () => import('@features/settings/settings-routing.module').then(m => m.SettingsRoutingModule),
    canActivate: [AuthGuard],
    data: { title: 'pageTitles.settings' }
  },
  {
    path: 'notifications',
    loadChildren: () => import('@features/notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AuthGuard],
    data: { title: 'notifications.title' }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutes { }
